module.exports = __webpack_public_path__ + "img/heartbeat-monitoring.2d19523f.png";